import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from 'reactstrap';
import { alertActions as depAlertActions } from '_actions';
import { alertActions } from '_reducers/alerts.reducer';

/**
 * Create CrAlert component.
 * @returns CrAlert component.
 */
const CrAlert = () => {
  const timeout = 15 * 1000; // 15 Seconds.
  const dispatch = useDispatch();

  /**
   * @deprecated Legacy reducers for alerts will be removed from store.entities in near future.
   * @name depricatedAlerts
   */
  const depAlerts = useSelector((store) => store?.entities.alerts);
  const alerts = useSelector((store) => Object.values(store?.ui.alerts));

  if (!depAlerts) return <></>;

  /**
   * @deprecated Alerts will be remove in near future. Use alerts instead.
   */
  const onDismiss = () => {
    dispatch(depAlertActions.clear());
  };

  /**
   * @deprecated Alerts will be remove in near future. Use alerts instead.
   */
  const renderMessage = (message) => {
    // Note - this will dismiss all the queued error messages at once.
    // Need some re-factoring to dismiss selected messages.
    setTimeout(() => {
      onDismiss();
    }, timeout);
    return ReactHtmlParser(message);
  };

  /**
   * To close the alert message.
   * @param {alertId} id id of the alert message.
   * @returns {void}
   */
  const closeAlert = (id) => dispatch(alertActions.clearAlert(id));

  /**
   * To get the alert message.
   * @param {Alert} t Alert object
   * @returns Html parsed message
   */
  const getMessage = (t) => {
    setTimeout(closeAlert, timeout, [ t.id ]);
    return ReactHtmlParser(t.message);
  };

  return (
    <div className='alertBox'>
      {depAlerts.message && (
        <Alert color={depAlerts.type} toggle={onDismiss}>
          {renderMessage(depAlerts.message)}
        </Alert>
      )}
      {alerts?.map((t) => (
        <Alert key={t.id} color={t.type} toggle={() => closeAlert(t.id)}>
          {getMessage(t)}
        </Alert>
      ))}
    </div>
  );
};

export default CrAlert;
